/*
 * @Author: Src
 * @Date: 2024-07-16 14:09:28
 * @LastEditTime: 2025-07-14 13:46:36
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/services/bi.service.ts
 * @Description: 头部注释配置模板
 */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { injectable, inject } from 'inversify';
import HttpClient from './http.service';

@injectable()
export default class BIService {
  @inject(HttpClient)
  protected http!: HttpClient;

  async shopReport() {
    // eslint-disable-next-line no-console
    console.log('aa');
  }
  async captcha(phone: any) {
    try {
      const result = (await this.http.get(`/captcha?phone=${phone}`)) as any;
      return result;
    } catch (error) {
      return null;
    }
  }
  /**
   * 获取BI报表token
   *
   * @return {*}  {(Promise<string | null>)}
   * @memberof OrderService
   */
  async BIToken(data: any): Promise<string | null> {
    try {
      const result = (await this.http.get('/bi/report-token', {params: data})) as string;
      return result;
    } catch (error) {
      return null;
    }
  }
}
